<template>
  <div class="relative">
    <button
      :class="buttonClasses"
      data-test-id="toggle-categories-menu-button"
      @click="isCategoriesMenuOpen = !isCategoriesMenuOpen"
    >
      {{ $t("navigation.categories") }}
      <arrow-icon class="w-3 h-3 ml-2 mt-1" :class="{ 'rotate-180': isCategoriesMenuOpen }" />
    </button>
    <logged-out-navigation-desktop
      :class="isCategoriesMenuOpen ? 'absolute top-8' : 'hidden'"
      :navigation-visible="isCategoriesMenuOpen"
      v-bind="$props"
      class="absolute top-8"
      @close="isCategoriesMenuOpen = false"
    />
  </div>
</template>

<script>
export default {
  name: "NavigationDesktop",
  data() {
    return {
      isCategoriesMenuOpen: false
    }
  },
  computed: {
    buttonClasses() {
      return {
        "flex items-center cursor-pointer": true,
        "font-medium text-midnight": true,
        "hover:text-blue focus:text-blue active:text-blue": true,
        "text-blue": this.isCategoriesMenuOpen
      }
    }
  }
}
</script>
